import { FormControl, FormLabel, Input, Text } from '@chakra-ui/react'
import CountrySelect from '../../../../../components/CountrySelect'
import { Profile } from '../../../../../types/FirestoreUser'
import PhoneNumberInput from './PhoneNumberInput'

interface AddressSectionProps {
  profile: Profile
  onUpdate: (changes: Partial<Profile>) => void
}

const AddressSection = ({ profile, onUpdate }: AddressSectionProps) => {
  return (
    <>
      <FormControl>
        <FormLabel>
          Street Address{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Input
          required
          autoComplete='address'
          defaultValue={profile.address || ''}
          onChange={(e) => onUpdate({ address: e.target.value })}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          City{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Input
          required
          autoComplete='address-level2'
          defaultValue={profile.city || ''}
          onChange={(e) => onUpdate({ city: e.target.value })}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          State/Province/Other{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Input
          required
          autoComplete='address-level1'
          defaultValue={profile.state || ''}
          onChange={(e) => onUpdate({ state: e.target.value })}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          Zip/Postal Code{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <Input
          required
          autoComplete='postal-code'
          defaultValue={profile.postalCode || ''}
          onChange={(e) => onUpdate({ postalCode: e.target.value })}
        />
      </FormControl>

      <FormControl>
        <FormLabel>
          Country{' '}
          <Text as='span' color='red.500'>
            *
          </Text>
        </FormLabel>
        <CountrySelect
          id='country'
          aria-label='Country'
          hideLabel
          defaultValue={profile.country}
          onChange={(country) => onUpdate({ country })}
        />
      </FormControl>

      <PhoneNumberInput
        phoneNumber={profile.phoneNumber || ''}
        phoneCountryCode={profile.phoneCountryCode}
        addressCountry={profile.country}
        isRequired
        onUpdate={onUpdate}
      />
    </>
  )
}

export default AddressSection
